import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SidebarStateFunction {

  /** Icon-rail collapsed state */
  readonly collapsed = signal<boolean>(false);

  /** Mobile off-canvas drawer state */
  readonly mobileOpen = signal<boolean>(false);

  toggleCollapse() { this.collapsed.update(v => !v); }
  setCollapsed(v: boolean) { this.collapsed.set(v); }

  toggleMobile() { this.mobileOpen.update(v => !v); }
  closeMobile() { this.mobileOpen.set(false); }
}